import { render, staticRenderFns } from "./VoiceSelectorModal.vue?vue&type=template&id=1b27a45a&scoped=true"
import script from "./VoiceSelectorModal.vue?vue&type=script&lang=ts"
export * from "./VoiceSelectorModal.vue?vue&type=script&lang=ts"
import style0 from "./VoiceSelectorModal.vue?vue&type=style&index=0&id=1b27a45a&prod&scoped=true&lang=scss"
import style1 from "./VoiceSelectorModal.vue?vue&type=style&index=1&id=1b27a45a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b27a45a",
  null
  
)

export default component.exports